import { Modal } from "antd";

const InfoModal = ({ content, ...props }) => {
    return (
        <Modal footer={null} {...props}>
            {content}
        </Modal>
    )
}

export default InfoModal